import React from 'react';
import Donut from './Donut/index.js';
import Bar from './Bar/index.js';
import StackedArea from './StackedArea/index.js';
import Axis from './Axis/index.js';

/* eslint-disable jsx-a11y/no-distracting-elements */
const Chart = () => {
  return <marquee>use Chart.Bar/Chart.Donut/Chart.StackedArea</marquee>;
};
/* eslint-enable jsx-a11y/no-distracting-elements */

Chart.displayName = 'Chart';

Chart.Donut = Donut;
Chart.Bar = Bar;
Chart.StackedArea = StackedArea;
Chart.Axis = Axis;

export default Chart;
export {
  Donut,
  Bar,
  StackedArea,
  Axis
};
export const {
  displayName
} = Chart;
